module.exports = __webpack_public_path__ + "img/responsive-mobile.914feb7b.jpg";